// extracted by mini-css-extract-plugin
module.exports = {"separator":"pageTitle-module--separator--334UJ","box":"pageTitle-module--box--1d57a"};